/**
 * "Detect local databases" for the New Connection dialog (Workstream B3; Option C, C1 renders it as a start-view
 * option, a rail row and an "Add from…" menu item) — the primary home for Docker auto-discovery, and (on Windows) native
 * SQL Server instance detection too. Starting it always runs the full merged detect (Docker + native probe).
 *
 * Unavailable, with the reason, only when Docker is absent on a non-Windows platform, where Docker is the sole
 * detection source (house rule: every unavailable control explains why) — on Windows it stays available even without
 * Docker, since the native probe finds SQLEXPRESS/LocalDB instances independently of it.
 */
import { openDockerDiscoveryDialog } from './dockerDiscoveryService';
import { useDockerAvailability } from './useDockerAvailability';

// Windows is the only platform the native SQL Server probe runs on (C2).
// Computed per-call (not module scope) so it reflects the runtime platform.
function isWindowsPlatform(): boolean {
  return typeof navigator !== 'undefined' && Boolean(navigator.platform?.toLowerCase().includes('win'));
}

export function useDetectLocalDatabases() {
  const { available, socketPath, loading } = useDockerAvailability();
  const unavailable = !loading && !available && !isWindowsPlatform();
  const unavailableReason = !unavailable
    ? undefined
    : socketPath
      ? `Docker socket not found at ${socketPath} — is Docker running?`
      : 'Docker socket not found — is Docker running?';
  return {
    unavailableReason,
    open: (placement: 'start' | 'rail' | 'compact') => void openDockerDiscoveryDialog('new_connection_dialog', placement),
  };
}
